// features/gptApi/gptApiSlice.js
import { createAsyncThunk, createSlice, createSelector } from '@reduxjs/toolkit';
import {HOSTNAME} from "../../Configs/Domain";
import { prepareJsonPayload } from "../utils";



export const fetchGptResponse = createAsyncThunk(
    'gptApi/fetchGptResponse',
    /**
     *
     * @param promptData {string} - The prompt to send to server to passthrough to GPT service
     * @param id {string} - The UUID of the prompt generated in useGptResponses hook
     * @param srcLocation {string, optional} - Where within the platform the prompt was generated
     * @param promptTemplate {string, optional} - The template used to generate the prompt
     * @param rejectWithValue
     */
    async ({ promptData, id, srcLocation, promptTemplate }, { rejectWithValue }) => {
        try {
            const response = await fetch(`${HOSTNAME}/service/gateway`,
                prepareJsonPayload({
                    data: { prompt: promptData,  template: promptTemplate },
                    method: "POST"
                }));
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            return { id, data, timestamp: new Date().toISOString(), srcLocation };  // Include UUID in the response
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


const gptApiSlice = createSlice({
    name: 'gptApi',
    initialState: {
        responses: {}, // Use an object keyed by UUID
        status: 'idle',
        error: null
    },
    reducers: {
        clearResponses: (state) => {
            state.responses = {};
        },
        removeResponseById: (state, action) => {
            delete state.responses[action.payload];
        },
        updateResponseById: (state, action) => {
            const { id, data } = action.payload;
            if (state.responses[id]) {
                state.responses[id].data = data;
                // Optionally update the timestamp or any other relevant metadata
                state.responses[id].timestamp = new Date().toISOString();
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchGptResponse.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchGptResponse.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.responses[action.payload.id] = action.payload;
            })
            .addCase(fetchGptResponse.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

const selectResponses = state => state.gptApi.responses;

export const selectResponseById = createSelector(
  [selectResponses, (state, responseId) => responseId],
  (responses, responseId) => responses[responseId]
);

export const { clearResponses, removeResponseById, updateResponseById } = gptApiSlice.actions;
export default gptApiSlice.reducer;